import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { DebounceInput } from './DebounceInput';
import { getParents } from '../../../redux/actions/clientActions';
import { formatPhone } from '../../../libs/commonHelper';
import MessageModal from '../../../shared/components/Modals/MessageModal';
import localStorage from '../../../libs/storageHelper';
import withRouter from '../../../shared/components/withRouter';

const defaultAvatar = `${process.env.PUBLIC_URL}/img/default.png`;
const initialState = {
  parent: null,
  searchKeyWord: '',
  isResultListOpen: false,
  parentList: [],
  isParentSelected: false,
  outSideClicked: false,
  awaitingSearch: false,
  searchCompleted: false,
  searchInputKey: 0,
};

class FindParent extends Component {
  constructor(props) {
    super(props);
    const user = localStorage.getFromStorage('loggedUser');
    this.state = {
      parent: null,
      searchKeyWord: '',
      isResultListOpen: false,
      parentList: [],
      key: 0,
      isParentSelected: false,
      awaitingSearch: false,
      searchCompleted: false,
      searchInputKey: 0,
      userType: user.user.type,
      responseBox: {
        showResponse: false,
        responseType: '',
        responseAlertType: '',
        responseFooter: '',
        message: '',
      },
    };
    this.doSearch = this.doSearch.bind(this);
    this.setParent = this.setParent.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    this.onClose = this.onClose.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  UNSAFE_componentWillMount() {
    document.addEventListener('mousedown', this.handleOutsideClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick, false);
  }

  componentDidMount() {
    // Autofocus owned here — New Appointment open (sidebar / route).
    // Skip when a parent was pre-selected (e.g. opened from client profile).
    if (!this.props.viewMode && !this.props.hideSearch && !this.props.defaultParent) {
      this.focusSearch();
    }
  }

  focusSearch = () => {
    // Defer so DebounceInput has attached via inputRef.
    requestAnimationFrame(() => {
      if (this.searchInput && typeof this.searchInput.focus === 'function') {
        this.searchInput.focus();
      }
    });
  };

  handleOutsideClick = (e) => {
    if (this.node && !this.node.contains(e.target)) {
      this.setState({
        isResultListOpen: false,
        outSideClicked: true,
      });
    }
  };

  UNSAFE_componentWillReceiveProps(np) {
    if (np.defaultParent) {
      this.pendingQuery = '';
      this.setState((prev) => ({
        parent: np.defaultParent,
        isResultListOpen: false,
        isParentSelected: true,
        searchKeyWord: '',
        awaitingSearch: false,
        searchCompleted: false,
        searchInputKey: prev.searchInputKey + 1,
      }));
    }
    if (
      np.client &&
      !this.state.outSideClicked &&
      this.state.awaitingSearch
    ) {
      const parentList = np.client.parentList ? np.client.parentList : [];
      const query = this.state.searchKeyWord.trim();
      const hasQuery = !!query;
      // Ignore stale responses from an older query while the user is still typing.
      if (hasQuery && this.pendingQuery !== query) {
        return;
      }
      this.setState({
        parentList,
        awaitingSearch: false,
        searchCompleted: hasQuery,
        isResultListOpen: hasQuery && parentList.length > 0,
      });
    }
    if (np.reset) {
      this.pendingQuery = '';
      this.setState(
        (prev) => ({
          ...initialState,
          searchInputKey: prev.searchInputKey + 1,
        }),
        () => {
          this.focusSearch();
        },
      );
    }
  }

  doSearch(e) {
    const searchKeyWord = e.target.value;
    const q = searchKeyWord.trim();

    this.setState(
      {
        searchKeyWord,
        outSideClicked: false,
        isResultListOpen: false,
        parentList: q ? this.state.parentList : [],
        awaitingSearch: !!q,
        searchCompleted: false,
      },
      () => {
        if (!q) {
          this.pendingQuery = '';
          this.setState({ parentList: [], isResultListOpen: false });
          return;
        }
        this.pendingQuery = q;
        this.props.getParents(q);
      },
    );
  }

  setParent(key) {
    const { parentList, isParentSelected, responseBox } = this.state;
    if (!isParentSelected) {
      this.pendingQuery = '';
      // Keep the typed search term visible after parent selection.
      this.setState(
        {
          parent: parentList[key],
          isResultListOpen: false,
          isParentSelected: true,
          awaitingSearch: false,
          searchCompleted: false,
        },
        () => {
          this.props.setSelectedParent(this.state.parent);
        },
      );
      return;
    }

    const hasUnsavedPets = Boolean(this.props.inputs?.pets?.length);
    if (hasUnsavedPets) {
      responseBox.showResponse = true;
      responseBox.responseFooter = true;
      responseBox.responseType = 'confirm';
      responseBox.message =
        'The changes you have made will be lost if you navigate away from this page.\n' +
        'Are you sure you want to leave this page?';
      this.setState({ responseBox, key });
      return;
    }

    this.setState({ key }, () => {
      this.onSuccess();
    });
  }

  clearSearch = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.pendingQuery = '';
    this.setState(
      (prev) => ({
        parent: null,
        searchKeyWord: '',
        isResultListOpen: false,
        parentList: [],
        isParentSelected: false,
        awaitingSearch: false,
        searchCompleted: false,
        outSideClicked: false,
        searchInputKey: prev.searchInputKey + 1,
      }),
      () => {
        // Clears parent + pet + Select Pet panel in CreateAppointment.
        this.props.setSelectedParent(null);
        this.focusSearch();
      },
    );
  };

  onClose() {
    const { responseBox } = this.state;

    responseBox.showResponse = false;
    responseBox.responseType = '';
    responseBox.responseAlertType = '';
    responseBox.responseFooter = '';
    responseBox.message = '';

    this.setState({ responseBox });
  }

  onSuccess() {
    const { parentList, key } = this.state;
    this.pendingQuery = '';
    this.setState(
      {
        parent: parentList[key],
        isResultListOpen: false,
        isParentSelected: true,
        awaitingSearch: false,
        searchCompleted: false,
      },
      () => {
        this.props.setSelectedParent(this.state.parent);
        this.onClose();
      },
    );
  }

  render() {
    const { collapse, viewMode } = this.props;
    const {
      parent,
      searchKeyWord,
      parentList,
      responseBox,
      searchCompleted,
      awaitingSearch,
    } = this.state;
    const parentImage =
      parent && parent.avatar ? `${parent.avatar}` : defaultAvatar;
    const showNoResults =
      !parent &&
      !!searchKeyWord.trim() &&
      searchCompleted &&
      !awaitingSearch &&
      parentList.length === 0;
    const layoutClass = parent
      ? 'find-parent-layout find-parent-layout--selected'
      : 'find-parent-layout';

    return (
      <div className="content-holder find-parent-wrapper">
        <div className={layoutClass}>
          <div className="find-parent-title">
            <h3>{this.props.title || 'Find Parent or Pet'}</h3>
          </div>
          <Collapse className="parent-collapse" isOpen={collapse}>
            <div className="find-parent-body">
              {!this.props.hideSearch && (
                <div className="find-parent-search-col">
                  {!viewMode && (
                    <div
                      className="search-wrapper"
                      ref={(node) => (this.node = node)}
                    >
                      <DebounceInput
                        key={this.state.searchInputKey}
                        className={
                          'form-control' +
                          (searchKeyWord ? ' has-search-clear' : '')
                        }
                        style={
                          searchKeyWord ? { paddingRight: '28px' } : undefined
                        }
                        placeholder="Search Parent, Pet, or Mobile Number"
                        onChange={this.doSearch}
                        onFocus={() => this.setState({ outSideClicked: false })}
                        value={this.state.searchKeyWord}
                        debounceTimeout={300}
                        type="text"
                        inputRef={(input) => {
                          this.searchInput = input;
                        }}
                      />
                      {!!searchKeyWord && (
                        <button
                          type="button"
                          className="search-clear-btn"
                          aria-label="Clear search"
                          onMouseDown={(e) => {
                            // Avoid blur/outside-click races before onClick.
                            e.preventDefault();
                            e.stopPropagation();
                          }}
                          onClick={this.clearSearch}
                          style={{
                            position: 'absolute',
                            right: '8px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            border: 'none',
                            background: 'transparent',
                            fontSize: '20px',
                            lineHeight: 1,
                            padding: '0 4px',
                            cursor: 'pointer',
                            color: '#666',
                            zIndex: 2,
                          }}
                        >
                          ×
                        </button>
                      )}
                      {this.state.isResultListOpen && (
                        <div className="list">
                          <div className="custom-scroll-bar">
                            {parentList.map((parentItem, key) => (
                              <div
                                className="list-item"
                                key={parentItem._id}
                                onClick={() => this.setParent(key)}
                              >
                                <p>
                                  {parentItem.name}{' '}
                                  <span className="phone">
                                    {parentItem.phone
                                      ? formatPhone(
                                          parentItem.phone,
                                          '(###) ###-####',
                                        )
                                      : ''}
                                  </span>
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {showNoResults && (
                    <div className="find-parent-actions">
                      <label className="no-parent-found">
                        No matching Parent or Pet found.
                      </label>
                    </div>
                  )}
                </div>
              )}

              {parent && (
                <div className="find-parent-selected-col">
                  <div className="parent-card">
                    <div className="parent-card-main">
                      <div className="hover-box">
                        <img
                          className="parent-image hover-box-layer_bottom"
                          src={parentImage}
                          alt="avatar"
                        />
                        <Link to={`/client-list/profile/${parent._id}`}>
                          <div className="hover-box-layer_top">
                            <div className="hover-box-text">View Profile</div>
                          </div>
                        </Link>
                      </div>
                      <div className="parent-card-info">
                        <p className="parent-name">
                          <Link to={`/client-list/profile/${parent._id}`}>
                            {parent.name}
                          </Link>
                        </p>
                        <p className="parent-email">{parent.email}</p>
                        <p className="parent-tel">
                          {parent.phone
                            ? formatPhone(parent.phone, '(###) ###-####')
                            : ''}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Collapse>
        </div>
        <MessageModal
          show={responseBox.showResponse}
          type={responseBox.responseType}
          alertType={responseBox.responseAlertType}
          footer={responseBox.responseFooter}
          onSuccess={this.onSuccess}
          onClose={this.onClose}
          message={responseBox.message}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = {
  getParents,
};

FindParent.propTypes = {
  collapse: PropTypes.bool.isRequired,
  reset: PropTypes.bool.isRequired,
  setSelectedParent: PropTypes.func.isRequired,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FindParent),
);
